module.exports = __webpack_public_path__ + "img/mug-tea.884dd3cf.svg";